<template>
  <div>
    <div class="row">
      <div class="col-md-12 p-0" v-if="catColorList.length > 0">
        <h1 v-if class="catcolor-title">{{ catColorList[0].family.descrizione }}</h1>

        <p  class="catcolor-description">
          {{ catColorList[0].family.des_estesa }}
        </p>
      </div>
    </div>
    <div class="container filter">
    <div class="row">
      <div class="col-md-12 filter-container">
        <product-filter v-if="catColorList[0].cod_macrofamiglia === 'CIN' || catColorList[0].cod_macrofamiglia === 'NAS'" />
      </div>
    </div>
    </div>
    <div class="row">
      <div class="col-md-12 n-prodotti">{{ catColorList.length }} {{ trans.get('public.filter.product') }}</div>
      <b-skeleton height="50" width="100" v-if="catColorList === null"/>
      <div
          class="col-lg-3 col-6 lista-catcolor"
          v-for="(catcolor, index) in catColorList" v-if="catColorList !== null"
          :key="index"
      >
        <product-card :key="index" class="productcard" :product="catcolor" />
      </div>
    </div>
  </div>
</template>

<script>
import productCard from "./product-card";
import productFilter from "./filter";

export default {
  name: "cat-color",
  components: { productCard, productFilter },
  data() {
    return {
      catColorList: this.$store.state.catalog.catcolor,
      cardLoaded: false,
    };
  },

  mounted() {
    this.setBread();
  },

  methods: {
    setBread: function () {
      this.$store.commit('setBread', this.catColorList[0])
      // this.$store.commit("setBread", {
      //   macro: {
      //     code: this.catColorList[0].cod_macrofamiglia,
      //     desc: this.catColorList[0].macrofamily.descrizione,
      //   },
      //   family: {
      //     code: this.catColorList[0].cod_famiglia,
      //     desc: this.catColorList[0].family.descrizione,
      //   },
      // });
    },
  },
};
</script>

<style lang="scss" scoped>
* {
  font-size: 1rem;
  @media (min-width: 1921px) {
    font-size: var(--font-size-large);
  }
}
h1,
p,
span {
  color: #fff;
}
.container.filter {
  @media (max-width: 576px) {
  width: 390px;
  }
}
.filter-container {

    padding: 0;

}
.n-prodotti {
  margin-bottom: 15px;
  margin-top: 53px;
}
.catcolor-title {
  font-size: 34px;
  text-transform: lowercase;
  padding-left: 15px;
  &:first-letter {
    text-transform: uppercase;
  }
}

.catcolor-description {
  margin: 15px 0;
  font-size: 14px;
}

.lista-catcolor {
  display: flex;
  padding: 0;
}
.lista-catcolor{
  padding-right: 15px;
}


@media (max-width: 576px){
  .lista-catcolor:nth-child(even){
    padding-right: 5px;
  }
  .lista-catcolor:nth-child(odd){
    padding-left: 5px;
    padding-right: 0;
  }
}
</style>
